<template>
  <div id="canvas">
    <div class="download-search">
      <div class="row">
        <div class="col-md-4">
          <nav aria-label="breadcrumb">
            <ol class="report-bread breadcrumb">
              <li class="breadcrumb-item"><a href="#">Report</a></li>
              <li class="breadcrumb-item active" aria-current="page">
                User Activity Report
              </li>
            </ol>
          </nav>
        </div>
        <div class="col-md-8">
          <div class="download-links">
            <ul class="d-flex align-items-center justify-content-end">
              <!---start--->
              <li class="timeline">
                <button
                  type="button"
                  v-on:click="reportfilter('today')"
                  v-bind:class="filters_.duration == 'today' ? 'current' : ''"
                >
                  <span class="today">Today</span>
                </button>
              </li>
              <li class="timeline">
                <button
                  type="button"
                  v-bind:class="filters_.duration == 'month' ? 'current' : ''"
                  v-on:click="reportfilter('month')"
                >
                  <span class="today">This Month</span>
                </button>
              </li>
              <li class="timeline datepicker-timeline">
                <button
                  type="button"
                  class="calender"
                  v-bind:class="filters_.duration == 'custom' ? 'current' : ''"
                >
                  <date-range-picker
                    :opens="'left'"
                    :ranges="false"
                    :locale-data="{ format: 'yyyy-mm-dd' }"
                    v-model="filters_.customDate"
                    @update="reportfilter('custom')"
                  ></date-range-picker
                  ><span class="calender">Custom Date</span>
                </button>
              </li>
              <li class="timeline">
                <button
                  @click="exportSalesRapData(filters_.duration)"
                  :disabled="btnLoader"
                  type="button"
                >
                  <span v-if="btnLoader"
                    ><span class="spinner-grow spinner-grow-sm"></span>
                    Loading...</span
                  >
                  <span v-if="!btnLoader"> Export CSV</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ounter-grid -->
    <div class="">
      <div class="dataTables_wrapper no-footer">
        <div class="graph-area">
          <div class="grap-title">
            <div class="title-grap">
              <h4>User Activity Report</h4>
            </div>
          </div>
          <table id="userActivityData" class="customReportsTable display">
            <thead>
              <tr>
                <th>User</th>
                <th class="text-center">Tasks Created</th>
                <th class="text-center">System Tasks Created</th>
                <th class="text-center">Total Tasks</th>
                <th class="text-center">Tasks Completed</th>
                <th class="text-center">Tasks Over Due</th>
                <th class="text-center">Average Days Over Due</th>
                <th class="text-center">% of Completed Tasks</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in orderbyactivity" :key="data.key">
                <td class="td">{{ data.agent_name }}</td>
                <td class="text-center">{{ data.tasks_created }}</td>
                <td class="text-center">{{ data.system_tasks_created }}</td>
                <td class="text-center">{{ data.total_tasks }}</td>
                <td class="text-center">{{ data.tasks_completed }}</td>
                <td class="text-center">{{ data.tasks_over_due }}</td>
                <td class="text-center">{{ data.average_over_due }}</td>
                <td class="text-center">{{ data.percentage_completed }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="dataTables_wrapper no-footer"
        v-if="
          this.$storage.get('auth').user.email == 'manager@genevamotors.com'
        "
      >
        <div class="graph-area">
          <div class="grap-title">
            <div class="title-grap">
              <h4>User Activity Performance</h4>
            </div>
          </div>
          <table id="useractivity_performance" class="customReportsTable display">
            <thead>
              <tr>
                <th>User</th>
                <th class="text-center">Showroom Ups</th>
                <th class="text-center">Phone Ups</th>
                <th class="text-center">Internet Ups</th>
                <th class="text-center">Calls</th>
                <th class="text-center">Emails</th>
                <th class="text-center">Texts</th>
                <th class="text-center">Appointment Created</th>
                <th class="text-center">Appt Created Shown</th>
                <th class="text-center">Visits</th>
                <th class="text-center">Sold</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in useractivity_performance" :key="data.key">
                <td class="td">{{ data.agent_name }}</td>
                <td class="text-center">{{ data.showroomup }}</td>
                <td class="text-center">{{ data.phoneup }}</td>
                <td class="text-center">{{ data.internetup }}</td>
                <td class="text-center">{{ data.calls }}</td>
                <td class="text-center">{{ data.emails }}</td>
                <td class="text-center">{{ data.texts }}</td>
                <td class="text-center">{{ data.appointment_created }}</td>
                <td class="text-center">{{ data.ApptCreatedShown }}</td>
                <td class="text-center">{{ data.visits }}</td>
                <td class="text-center">{{ data.sold }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- graph-area -->
</template>
<script>
import axios from "axios";
// import VueApexCharts from "vue-apexcharts";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import axios from "axios";
// import moment from "moment";
// import jsPDF from "jspdf";
// import * as htmlToImage from "html-to-image";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-responsive";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import moment from "moment";
import { orderBy } from "lodash";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
export default {
  name: "UserActivityReport",
  components: { DateRangePicker },
  data() {
    return {
      btnLoader: false,
      userActivityData: null,
      useractivity_performance: null,
      userActivityDataObject: null,
      filters_: {
        duration: "month",
        customDate: {},
        id: 0,
        tm_id: 0,
        from: "",
        to: "",
        export: false,
      },
    };
  },
  mounted() {
    this.getUserActivityReport();
    this.useractivityPerformance();
  },
  computed: {
    orderbyactivity: function () {
      return orderBy(this.userActivityData, "total_tasks", "desc");
    },
  },
  beforeUpdate() {
    if (this.userActivityDataObject) {
      this.userActivityDataObject.fnDestroy();
    }
  },
  methods: {
    exportSalesRapData(duration) {
      console.log(duration);
      this.filters_.export = true;
      this.btnLoader = true;
      let startDate = this.filters_.customDate.startDate;
      let endDate = this.filters_.customDate.endDate;
      this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
      this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
      this.filters_.duration = duration;
      axios
        .post(axios.defaults.baseURL + "useractivityreport", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.filters_.export = false;
          this.btnLoader = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "useractivity.csv");
          document.body.appendChild(fileLink);
          fileLink.click();
        });
    },
    reportfilter(duration = "month") {
      this.getUserActivityReport(duration);
      this.useractivityPerformance(duration);
    },
    getUserActivityReport(duration = "month") {
      let startDate = this.filters_.customDate.startDate;
      let endDate = this.filters_.customDate.endDate;
      this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
      this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
      this.filters_.duration = duration;
      axios
        .post(axios.defaults.baseURL + "useractivityreport", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((response) => {
          if ($.fn.DataTable.isDataTable("#userActivityData")) {
            $("#userActivityData").DataTable().destroy();
          }
          this.userActivityData = response.data;
          setTimeout(() => {
            if ($.fn.DataTable.isDataTable("#userActivityData")) {
              $("#userActivityData").DataTable().draw();
            } else {
              $("#userActivityData").DataTable({
                responsive: true,
                paging: false,
                bFilter: false,
                ordering: false,
                bInfo: false,
              });
            }
          });
        });
    },
    useractivityPerformance(duration = "month") {
      let startDate = this.filters_.customDate.startDate;
      let endDate = this.filters_.customDate.endDate;
      this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
      this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
      this.filters_.duration = duration;
      axios
        .post(axios.defaults.baseURL + "useractivity_performance", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((response) => {
          if ($.fn.DataTable.isDataTable("#useractivity_performance")) {
            $("#useractivity_performance").DataTable().destroy();
          }
          this.useractivity_performance = response.data;
          console.log(response.data);
          setTimeout(() => {
            if ($.fn.DataTable.isDataTable("#useractivity_performance")) {
              $("#useractivity_performance").DataTable().draw();
            } else {
              $("#useractivity_performance").DataTable({
                responsive: true,
                paging: false,
                bFilter: false,
                ordering: false,
                bInfo: false,
              });
            }
          });
        });
    },
  },
};
</script>
<style scoped>
.timeline {
  margin: 0px !important;
}
.datepicker-timeline {
  overflow: visible;
  margin-right: 5px !important;
}
.calender {
  position: relative;
}
.calender .vue-daterange-picker {
  position: absolute;
}
.calender .daterangepicker.opensleft {
  right: -100px;
}
.td {
  position: relative;
  right: -7px;
}
@import "../../assets/css/dataTables.css";
</style>
